export const getMessageTime = (message) =>
	new Date(message.created_at).getTime();
